<template>
  <div class="maps" style="height: 62px;width: 100%;">
    <div style="width: 100%;height: 100%" id="container"></div>
  </div>
</template>

<script>
import AMap from 'AMap';
import moment from 'moment';
import { getGpsDatas, lastGpsLocation } from '../api/order';

async function run() {
  console.log(this.form.order);
  let startDate = null;
  let endDate = null;
  if (this.form.order.deliveryAt) {
    startDate = moment(this.form.order.deliveryAt).format('YYYY-MM-DD HH:mm:ss');
  } else {
    startDate = moment(this.form.order.createAt).format('YYYY-MM-DD HH:mm:ss');
  }
  if (this.form.order.receiveAt) {
    endDate = moment(this.form.order.receiveAt).format('YYYY-MM-DD HH:mm:ss');
  }
  const gpsLocations = await lastGpsLocation({
    gpsId: this.form.order.gpsNo ? this.form.order.gpsNo.trim() : null,
    startTime: startDate,
    endTime: endDate,
  });
  if (gpsLocations.code === 1200) {
    // console.log("================== gps locations ====================");
    // console.log(gpsLocations);
    this.middilePoint.push(gpsLocations.data.gpsLastLocation.longitude, gpsLocations.data.gpsLastLocation.latitude);
    this.arriveAddress = gpsLocations.data.gpsLastLocation.location;
    this.arriveAt = moment(gpsLocations.data.gpsLastLocation.time).format('YYYY-MM-DD HH:mm:ss');
    this.dis = gpsLocations.data.gpsLastLocation.dis;
    this.states = gpsLocations.data.gpsLastLocation.states;
  }

  // 高德API Key
  const key = '0e15fc1137f9156d8275bf2d94998c15';
  // 地址
  const address = this.form.order.receiveAddress ? this.form.order.receiveAddress : this.form.order.receiveCity;
  // 高德API地理编码URL
  const url = `https://restapi.amap.com/v3/geocode/geo?key=${key}&address=${encodeURIComponent(address)}`;
  let longitude;
  let latitude;

  await fetch(url)
      .then(response => response.json())
      .then((data) => {
        if (data.status === '1') {
          const { location } = data.geocodes[0];
          // eslint-disable-next-line prefer-destructuring
          longitude = location.split(',')[0];
          // eslint-disable-next-line prefer-destructuring
          latitude = location.split(',')[1];
          console.log(`经度: ${longitude}, 纬度: ${latitude}`);
        } else {
          console.error('地址查询失败:', data.info);
        }
      })
      .catch((error) => {
        console.error('请求出错:', error);
      });

  if (this.form.order.receiveLatlng !== '失败') {
    // console.log(this.form.order.receiveLatlng)
    const result = await getGpsDatas({
      ifsNo: this.form.order.ifsNo,
      gpsId: this.form.order.gpsNo ? this.form.order.gpsNo.trim() : null,
      lat: latitude,
      lng: longitude,
      startTime: startDate,
      endTime: endDate,
    });
    const _this = this;
    console.log('=================', result);
    if (result.code === 1200) {
      if (this.form.order.receiveLatlng === '失败') {
        this.$message.error('获取收货地址经纬度失败');
      } else if (result.data.gpsData.length > 0 || result.data.gpsDataGrey.length > 0) {
        if (result.data.gpsData.length > 0) {
          this.takePath.push(new AMap.LngLat(parseFloat(_this.startPoint[0]), parseFloat(_this.startPoint[1])));
          result.data.gpsData.forEach((x) => {
            // 检查 x[0] 和 x[1] 是否为有效的数字，并且不为 NaN
            const lng = parseFloat(x[0]);
            const lat = parseFloat(x[1]);

            if (lng && lat) {
              if (window.AMap) {
                // 确保 AMap 已经加载
                const lngLat = new AMap.LngLat(lng, lat);
                _this.takePath.push(lngLat);
              } else {
                console.log('高德AMap未成功加载');
              }
            }
          });
        }
        if (result.data.gpsDataGrey.length > 0) {
          console.log('gpsDataGrey');
          result.data.gpsDataGrey.forEach((x) => {
            // 检查 x[0] 和 x[1] 是否为有效的数字，并且不为 NaN
            const lng = parseFloat(x[0]);
            const lat = parseFloat(x[1]);

            if (lng && lat) {
              if (window.AMap) {
                // 确保 AMap 已经加载
                const lngLat = new AMap.LngLat(lng, lat);
                console.log('---->lnglat: ', lngLat);
                _this.greyPath.push(lngLat);
              } else {
                console.log('高德AMap未成功加载');
              }
            }
          });
        }
        const path = this.takePath;
        const pathGrey = this.greyPath;


        // const split = this.form.order.receiveLatlng.split(',');
        this.endPoint.push(longitude, latitude);
        console.log('--------->endpoint ', this.endPoint);
        if (this.form.order.orderStatus === 'CLOSED') {
          _this.greyPath.push(new AMap.LngLat(parseFloat(_this.endPoint[0]), parseFloat(_this.endPoint[1])));
        }
        this.path.push({ lnglat: this.startPoint });
        this.path.push({ lnglat: this.endPoint });
        this.planPath.push({ lnglat: this.middilePoint });
        this.planPath.push({ lnglat: this.endPoint });
        const time = this.form.order.deliveryAt;
        this.days = this.dateDiff(time);
        const map = new AMap.Map('container', {
          center: [this.middilePoint[0], this.middilePoint[1]],
          zoom: 10,
        });
        const polyline = new AMap.Polyline({
          path,
          strokeWeight: 5, // 线条宽度
          strokeColor: '#7a13b5', // 线条颜色
          isOutline: true,	// 是否描边
          outlineColor: '#fff', // 描边颜色
          borderWeight: 3, // 描边宽
        });
        const polylineGrey = new AMap.Polyline({
          path: pathGrey,
          strokeWeight: 5, // 线条宽度
          strokeColor: '#9ea0b5', // 线条颜色
          isOutline: true,	// 是否描边
          outlineColor: '#fff', // 描边颜色
          borderWeight: 3, // 描边宽
          strokeOpacity: 0.5,
        });
        map.add(polyline);
        map.add(polylineGrey);

        // 定义图标信息
        const icon = new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(32, 46),
          // 图标的取图地址
          image: 'http://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
          // 图标所用图片大小
          imageSize: new AMap.Size(32, 46),
        });
          // 文字描述内容
        const labelContent = "<span style='color: white'>起</span>";
        // 文字描述显示位置
        const labelOffset = new AMap.Pixel(8, 7);
        // 绘制坐标点
        const marker = new AMap.Marker({
          icon,
          position: this.startPoint,
          offset: new AMap.Pixel(-10, -46),
          text: '起',
          label: {
            content: labelContent,
            offset: labelOffset,
          },
        });
        marker.setMap(map);
        console.log('marker--->',map)
        const labelContenta = "<span style='color: white'>终</span>";
        const labelOffseta = new AMap.Pixel(8, 7);
        // console.log("=================== end point ===================");
        // console.log(this.endPoint);
        const marker2 = new AMap.Marker({
          icon,
          anchor: 'center', // 设置锚点
          position: this.endPoint,
          offset: new AMap.Pixel(-10, -28),
          text: '终',
          bubble: true,
          label: {
            content: labelContenta,
            offset: labelOffseta,
          },
        });
        marker2.setMap(map);
        marker2.on('click', () => {
          const infoWindow = new AMap.InfoWindow({
            content: `<div style='margin-bottom: 5px'>收货地址为：${this.recieveAddress}</div>
                    <div style='margin-bottom: 5px' v-if="showTime">收货时间为：${this.recieveAt}</div>`, // 使用默认信息窗体框样式，显示信息内容
          });
          infoWindow.open(map, this.endPoint);
        });
        console.log('marker2--->',map)
        // 绘制路线
        // map.plugin('AMap.TruckDriving', () => {
        //   const truckDriving = new AMap.TruckDriving({
        //     map,
        //     policy: 0, // 规划策略
        //     size: 1, // 车型大小
        //     showTraffic: true, // 去掉实时路况
        //     hideMarkers: true,
        //     isOutline: false,
        //     outlineColor: '#28F',
        //     autoFitView: true,
        //     strokeColor: '#04be02', // 线颜色
        //     strokeOpacity: 1, // 线透明度
        //     strokeWeight: 10, // 线宽
        //     strokeStyle: 'solid', // 线样式
        //     lineJoin: 'round', // 折线拐点的绘制样式
        //   });
        //   truckDriving.search(this.path, (status, result) => {
        //     // searchResult即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
        //     // if (status === 'complete') {
        //     //   this.distance = result.routes[0].distance / 1000; // 里转换成公里
        //     //   this.aging = this.secondToDay(result.routes[0].time); // 秒换算成天
        //     // }
        //     //
        //     // console.log(status)
        //     // const marker3 = new AMap.Marker({
        //     //   anchor: 'center', // 设置锚点
        //     //   position: this.middilePoint,
        //     //   bubble: true,
        //     // });
        //     // marker3.setMap(map);
        //     // marker3.on('click', () => {
        //     //   const infoWindow = new AMap.InfoWindow({
        //     //     content: `<div><div style='margin-bottom: 5px'>途经点：</div>
        //     //               <div style='margin-bottom: 5px'>设备名称：${this.gpsNo}</div>
        //     //               <div style='margin-bottom: 5px'>总里程：${this.dis}KM</div>
        //     //               <div style='margin-bottom: 5px'>状态：${this.states}</div>
        //     //               <div style='margin-bottom: 5px'>到达时间：${this.arriveAt}</div>
        //     //               <div style='margin-bottom: 5px'>到达地点：${this.arriveAddress}</div>
        //     //               <div style='margin-bottom: 5px'>距离终点${this.distance}公里</div>`, // 使用默认信息窗体框样式，显示信息内容
        //     //   });
        //     // //
        //     // //   /* <div style='margin-bottom: 5px'>已行驶${this.days}天</div>
        //     // //   <div style='margin-bottom: 5px'>预计还需行驶${this.aging}天</div>
        //     // //   </div></div> */
        //     //   infoWindow.open(map, this.middilePoint);
        //     // });
        //   });
        // });
        //
        if (this.form.order.orderStatus !== 'CLOSED') {
          map.plugin('AMap.TruckDriving', () => {
            const truckDriving = new AMap.TruckDriving({
              map,
              policy: 0, // 规划策略
              size: 1, // 车型大小
              showTraffic: false, // 去掉实时路况
              hideMarkers: true,
              isOutline: false,
              outlineColor: '#720d2a',
              autoFitView: true,
              strokeColor: '#230816', // 线颜色
              strokeOpacity: 1, // 线透明度
              strokeWeight: 20, // 线宽
              strokeStyle: 'solid', // 线样式
              lineJoin: 'round', // 折线拐点的绘制样式
            });
            truckDriving.search(this.planPath, (status, result) => {
              // searchResult即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
              // eslint-disable-next-line no-empty
              if (status === 'complete') {

              }
            });
          });
        }
      } else {
        this.$message.error('暂无物流信息');
      }
    }
  } else {
    this.$message.error('获取收货地址经纬度失败');
  }
}

function dateDiff(targetDate) {
  let date1 = new Date(targetDate);
  let date2 = new Date();
  date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
  date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  const diff = date2.getTime() - date1.getTime();
  const diffDate = diff / (24 * 60 * 60 * 1000);
  return diffDate;
}

function secondToDay(mss) {
  let days = Math.floor(mss / (60 * 60 * 24));
  const hours = Math.floor((mss % (60 * 60 * 24)) / (60 * 60));
  if (hours > 6) {
    days += 1;
  }
  return days;
}


export default {
  name: 'Gps',
  props: {
    order: Object,
  },
  destroyed() {
  },
  data() {
    return {
      form: {
        order: {},
        data: {
          orderId: '',
        },
      },
      path: [],
      // greyPath: [],
      takePath: [],
      greyPath: [],
      planPath: [],
      arriveAt: '',
      dis: '',
      states: '',
      gpsNo: '',
      recieveAddress: '',
      showTime: false,
      recieveAt: '',
      arriveAddress: '',
      startPoint: [],
      middilePoint: [],
      endPoint: [],
      distance: '',
      days: '',
      aging: '',
      lableShow: false,
    };
  },
  created() {
  },
  watch: {
    order(val) {
      this.form.order = val;
      this.takePath = [];
      this.greyPath = [];
      this.arriveAt = '';
      this.recieveAddress = '';
      this.showTime = false;
      this.recieveAt = '';
      this.arriveAddress = '';
      this.startPoint = [];
      this.middilePoint = [];
      this.endPoint = [];
      this.distance = '';
      this.days = '';
      this.aging = '';
      this.run();
    },
  },
  mounted() {
    this.form.order = this.order || {};
    this.gpsNo = this.form.order.gpsNo;
    if (this.form.order.receiveAddress) {
      this.recieveAddress = this.form.order.receiveAddress;
    } else {
      this.recieveAddress = this.form.order.receiveCity;
    }
    if (this.form.order.orderStatus === 'CLOSED') {
      this.showTime = true;
      this.recieveAt = this.form.order.receiveAt;
    }
    if (this.form.order.sendCity === '北京') {
      this.startPoint.push(116.556329, 39.758114);
    } else if (this.form.order.sendCity === '苏州') {
      this.startPoint.push(120.516228, 31.181837);
    } else if (this.form.order.sendCity === '天津') {
      this.startPoint.push(117.11, 39.32);
    } else if (this.form.order.sendCity === '长垣') {
      this.startPoint.push(114.700623, 35.155102);
    } else if (this.form.order.sendCity === '上虞') {
      this.startPoint.push(120.812429, 30.039461);
    } else {
      this.startPoint.push(121.515763, 31.303758);
      this.$message.error('发货地址异常');
    }
    if (this.form.data.order !== null) {
      this.run();
    }
  },
  methods: {// 定义方法
    run,
    dateDiff,
    secondToDay,
  },
};
</script>

<style>
  .maps .amap-marker-label {
    border: none;
    background-color: transparent;
  }
</style>
<style scoped="">
  .map-lable-content {
    width: 150px;
    height: 100px;
    border-radius: 0px !important;
    background-color: #3c3c3c;
    color: #fff;
    padding: 0 !important;
    margin: 34px 0 0 -18px;
  }

</style>
<style>
  .amap-info-content {
    background: #3c3c3c;
    color: #fff;
    opacity: 0.7;
  }
</style>
